import type { ReactNode } from 'react';
import { usePermission } from '../auth/context';
import { ErrorMessage } from '../components/ui';
import { strings } from '../strings';

/** Cloud accounts need the operator role (spec 6.6): direct links show why. */
export function OperatorsOnly({ children }: { children: ReactNode }) {
  const allowed = usePermission('operate');
  return allowed ? <>{children}</> : <ErrorMessage error={new Error(strings.cloudAccounts.noOperator)} />;
}

export function NotFound() {
  return <ErrorMessage error={new Error(strings.common.notFound)} />;
}
